import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import NavigationLink from 'shared/components/NavigationLink/NavigationLink';
import s from './InlineNav.css';

class InlineNav extends React.Component {
  static propTypes = {
    navLinks: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        route: PropTypes.string,
        count: PropTypes.string,
      }),
    ).isRequired,
    including: PropTypes.bool,
    currentRoute: PropTypes.string,
    eventPrefix: PropTypes.string,
  };

  static defaultProps = {
    including: true,
    currentRoute: null,
    count: null,
    withCount: false,
    eventPrefix: '',
  };

  render() {
    const { navLinks, including, currentRoute } = this.props;
    const route = `${currentRoute}/`.replace('//', '/');
    return (
      <div className={s.root} role="navigation">
        <ul className={s.list}>
          {navLinks.map(item =>
            <li key={item.route} className={s.item}>
              <NavigationLink
                link={item}
                currentRoute={route}
                including={including}
                className={s.link}
                activeClassName={s.active}
                eventPrefix={this.props.eventPrefix}
              />
            </li>,
          )}
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(InlineNav);



// WEBPACK FOOTER //
// ./src/desktop/components/InlineNav/InlineNav.js